<template>
	<main class="container">
		<div id="div-h1">
			<h1>Botiga</h1>
		</div>
		<div id="txt-descripcio">
			<p>
				Properament
			</p>
		</div>
	</main>
</template>

<style scoped>
	#txt-descripcio{
		margin-top: 40px;
		background: #e8e1ce;
		padding: 20px;
		text-align: center;
	}
</style>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Botiga.vue